import React, { FC, useEffect, useState } from 'react';
import { TransferProps }                  from 'antd';
import { TransferDirection, TransferItem } from 'antd/lib/transfer';
import { UnknownAction }                   from 'redux';
import { IFilterSettings }                 from 'Domain/Repositories/BaseRepository/BaseRepository';
import { useSubject }                      from 'View/HookApi';
import { debounceTime }                    from 'rxjs';
import { useDispatch, useSelector }        from 'react-redux';
import { Transfer }                        from '../Transfer/Transfer';
import { Key }                             from 'antd/es/table/interface';
import { TRootState }                      from 'Redux/Reducers';
import { IFilterProps }                    from 'Utils';

type TProps = TransferProps<TransferItem> & {
  header?: string[],
  fetchAction: (payload: IFilterSettings) => UnknownAction,
  sortField?: string,
  defaultValue?: any,
  isLoading?: (state: TRootState) => boolean,
  dataQuery: (state: TRootState, filter?: null | IFilterProps<any>) => unknown[],
  sourceMap?: { key: string, title: string },
  renderItem?: (entry: any) => any,
}

export const RemoteTransfer: FC<TProps> = ({ fetchAction, sortField = 'name', onChange, renderItem, sourceMap = { key: 'id', title: 'name' }, dataQuery, defaultValue, ...props }) => {

  const dispatch = useDispatch();
  const [ targetKeys, setTargetKeys ] = useState<Key[]>(defaultValue ? defaultValue.map((e: any) => e.id) : []);

  const onSearch$ = useSubject((value: string) => {
    const filterProps: IFilterSettings = {
      sorting   : { field: sortField, order: 'ASC' },
      pagination: { page: 1, take: 50 }
    };
    if (!value || `${value}`.trim() === '') {
      return request(filterProps);
    }

    request({
      filter: [ { field: 'search', value: `%${value}%` } ],
      ...filterProps,
    });
  }, [], debounceTime(500));

  useEffect(() => {
    onSearch$.next('');
  }, []);

  // @ts-ignore
  const dataSource = (useSelector<TRootState>(dataQuery) || []).map((entry: any) => ({
    key: entry[sourceMap.key],
    title: entry[sourceMap.title],
  }));

  const handleOnChange = (nextTargetKeys: Key[], direction: TransferDirection, moveKeys: Key[]) => {
    setTargetKeys(nextTargetKeys);
    onChange && onChange(nextTargetKeys, direction, moveKeys);
  }

  const handleOnSearch = (direction: TransferDirection, value: string) => {
    if(direction === 'right') { return; }
    onSearch$.next(value);
  }

  const request = (filterProps: IFilterSettings) => {
    dispatch(fetchAction(filterProps));
  }

  return (
    <Transfer
      {...props}
      targetKeys={targetKeys}
      dataSource={dataSource}
      render={renderItem || ((item: any) => item.title)}
      operations={[ 'zuordnen', 'entfernen' ]}
      locale={ props.locale || {
        itemUnit       : 'Eintrag',
        itemsUnit      : 'Einträge',
        notFoundContent: 'Keine Einträge Vorhanden'
      }}
      listStyle={{ height: 400 }}
      filterOption={
        props.filterOption ||
        ((input: string, {title }) => `${title}`.toLowerCase().indexOf(input.toLowerCase()) >= 0)
      }
      showSearch
      onChange={handleOnChange}
      onSearch={handleOnSearch}
    />
  );

};
